import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const SaveCampaign = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveCampaign,
        method: RequestType.POST,
        data,
    });

const UpdateStatus = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateStatus,
        method: RequestType.POST,
        data,
    });

const InsertImage = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.InsertImage,
        method: RequestType.POST,
        data,
    });

const InsertImageMultiple = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.InsertImageMultiple,
        method: RequestType.POST,
        data,
    });

const CreateBadgeFolder = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CreateBadgeFolder,
        method: RequestType.POST,
        data,
    });

const SaveUniqueCoupon = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveUniqueCoupon,
        method: RequestType.POST,
        data,
    });

const SaveMultipleCoupon = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveMultipleCoupon,
        method: RequestType.POST,
        data,
    });

const SaveMultipleCouponCustomer = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveMultipleCouponCustomer,
        method: RequestType.POST,
        data,
    });

const SaveThirdPartyCoupon = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveThirdPartyCoupon,
        method: RequestType.POST,
        data,
    });

const FileUpload = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.FileUpload,
        method: RequestType.POST,
        requestType: 'FromForm',
        data,
    });

const DownloadFile = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DownloadFile,
        method: RequestType.POST,
        data,
    });

const DownloadFileFilter = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DownloadFileFilter,
        method: RequestType.POST,
        data,
    });

const DownloadSlaveExcelFileFilter = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DownloadSlaveExcelFileFilter,
        method: RequestType.POST,
        data,
    });

const SaveRule = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveRule,
        method: RequestType.POST,
        data,
    });

const ReUpdateRuleProcessOrder = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.ReUpdateRuleProcessOrder,
        method: RequestType.POST,
        data,
    });

const SaveRuleCondition = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveRuleCondition,
        method: RequestType.POST,
        data,
    });

const SaveRuleConditionFile = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveRuleConditionFile,
        method: RequestType.POST,
        data,
    });

const SaveEarning = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveEarning,
        method: RequestType.POST,
        data,
    });

const ReUpdateEarningProcessOrder = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.ReUpdateEarningProcessOrder,
        method: RequestType.POST,
        data,
    });

const SetRuleForEarning = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SetRuleForEarning,
        method: RequestType.POST,
        data,
    });

const SaveMultipleCampaignFileFilter = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SaveMultipleCampaignFileFilter,
        method: RequestType.POST,
        data,
    });

const GenerateCampaignAIDescription = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GenerateCampaignAIDescription,
        method: RequestType.POST,
        data,
    });

const CampaignManagementCommand = {
    SaveCampaign,
    UpdateStatus,
    InsertImage,
    InsertImageMultiple,
    CreateBadgeFolder,
    SaveUniqueCoupon,
    SaveMultipleCoupon,
    SaveMultipleCouponCustomer,
    SaveThirdPartyCoupon,
    FileUpload,
    DownloadFile,
    DownloadFileFilter,
    DownloadSlaveExcelFileFilter,
    SaveRule,
    ReUpdateRuleProcessOrder,
    SaveRuleCondition,
    SaveRuleConditionFile,
    SaveEarning,
    ReUpdateEarningProcessOrder,
    SetRuleForEarning,
    SaveMultipleCampaignFileFilter,
    GenerateCampaignAIDescription,
};

export default CampaignManagementCommand;
